import {ISocial} from "@dp-instant/social";
import {ShareComponent, UIEvents, useInjection, visibilityEffect} from "@dp-instant/ui";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {IEventEmitter, TypesCore, TypesSocial} from "@dp-instant/interfaces";
import {CoinsIndicator} from "@game/ui/components/CoinsIndicator/CoinsIndicator";
import {NoThanksButton} from "@game/ui/components/NoThanksButton/NoThanksButton";
import {Winner} from "@game/ui/components/Winner/Winner";
import {WinRays} from "@game/ui/components/WinRays/WinRays";
import {WinStars} from "@game/ui/components/WinStars/WinStars";
import {UIConstants} from "@game/ui/constants";
import cn from "classnames";
import "./SharePopup.less";
import {WaitAction} from "@dp-instant/core";
import {Localize} from "@dp-instant/i18n";
import {ContinueButton} from "@game/ui/components/ContinueButton/ContinueButton";
import {Playdeck} from "@game/coregame/utils/Playdeck";

type ShareLevelResultPopupProps = {
    levelName: string;
    points: number;
    shareImage?: string;
    onContinue: (success: boolean) => void | Promise<void>;
};

export const ShareLevelResultPopup = ({shareImage, onContinue}: ShareLevelResultPopupProps) => {
    const model = useInjection<GameModel>(TypesGame.model);
    const social = useInjection<ISocial>(TypesSocial.model);
    const dispatcher = useInjection<IEventEmitter>(TypesCore.dispatcher);
    const [invisible, setInvisible] = visibilityEffect(UIConstants.popup.startDelay);
    const levelImage = model.screenshots[model.screenshots.length - 1];

    const close = async (shared = false) => {
        setInvisible(true);
        await WaitAction.ms(UIConstants.coinsIndicator.updateDelay);
        dispatcher.emit(UIEvents.POPUP, {id: null});
        onContinue && (await onContinue(shared));
    };

    return (
        <div className={cn("popups")}>
            <div className={cn("coins-bar")}>
                <CoinsIndicator
                    className={cn("coins-indicator", "coins-indicator_filled")}
                    total={model.cookie.coins}
                />
            </div>
            <div className={cn("popup-share-level-completed")}>
                <div className={cn("popup", {invisible})}>
                    <div className="popup__title">
                        <div className="popup__title-detailed">
                            {Localize.get("level_completed_message", "ALL STAGES COMPLETED!")}
                        </div>
                    </div>
                    <div className="popup__body">
                        <Winner photo={window.playdeckUser.avatar} />
                        <WinRays />
                        <WinStars />
                        <img className={cn("level-image")} src={levelImage} />
                    </div>
                    {shareImage && shareImage !== "" ? (
                        <NoThanksButton
                            delay={UIConstants.popup.noThanksButtonDelay}
                            onClick={close}
                        />
                    ) : (
                        <ContinueButton onClick={close} />
                    )}
                </div>
            </div>
        </div>
    );
};
